const Search = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M3.22667 13.1308C4.01013 14.9742 5.49382 16.431 7.35134 17.1805C9.20886 17.9301 11.2881 17.911 13.1315 17.1276C14.975 16.3441 16.4317 14.8604 17.1813 13.0029C17.9308 11.1454 17.9118 9.06617 17.1283 7.2227C16.3449 5.37922 14.8612 3.92248 13.0037 3.17294C11.1461 2.42339 9.06694 2.44244 7.22347 3.2259C5.38 4.00936 3.92325 5.49305 3.17371 7.35057C2.42416 9.20809 2.44322 11.2873 3.22667 13.1308Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M15.5175 15.5167L21.375 21.3751"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Search;
